import { RefObject } from 'react';

import { CustomerInformation } from '@/components/state/interfaces';
import { Dictionary, isNotEmpty } from '@proprioo/hokkaido';

import { ExtendedProject } from '../sellerQualification/interfaces';

export type SellerForm = {
  customer: CustomerInformation;
  project: ExtendedProject;
};

enum USER_ERRORS {
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE = 'phone'
}

enum AREA_ERRORS {
  ADDRESS = 'address',
  CITY = 'city',
  LOCATION = 'location',
  POSTAL_CODE = 'postalCode',
  STREET = 'street',
  STREET_NUMBER = 'streetNumber'
}

export const getErrorType = (errors: Dictionary) => ({
  isGlobalError: isNotEmpty(errors.global),
  isProjectError: includesProjectError(errors),
  isUserError: includesUserError(errors)
});

export const includesUserError = (errors: Dictionary) =>
  Object.keys(errors).filter(error =>
    Object.values(USER_ERRORS).includes(error as USER_ERRORS)
  ).length > 0;

export const includesProjectError = (errors: Dictionary) =>
  Object.keys(errors).filter(
    error =>
      !Object.values(USER_ERRORS).includes(error as USER_ERRORS) &&
      error !== 'global'
  ).length > 0;

export const includesAreaError = (errors: Dictionary) =>
  Object.keys(errors).filter(error =>
    Object.values(AREA_ERRORS).includes(error as AREA_ERRORS)
  ).length > 0;

export const scrollToRef = (ref: RefObject<HTMLDivElement>) =>
  window.scrollTo(0, ref.current?.offsetTop || 0);
